// removed by extract-text-webpack-plugin
module.exports = {"data-settings-page":"data-settings-page","data-action-button":"data-action-button","button-generate-backup":"button-generate-backup","button-restore-data":"button-restore-data","button-export-data":"button-export-data","button-download-data":"button-download-data","data-download-label":"data-download-label"};


//////////////////
// WEBPACK FOOTER
// ./src/application/scene/authorized/scene/settings/scene/data/data.style.sass
// module id = beF3
// module chunks = 0